import React from 'react'
import ExternalLink from '../external-link'
import ExternalLinkStyles from '../external-link/index.module.scss'
import YoutubeLink from '../youtube-link'
import { getYoutubeUrlDetails } from '../../helpers/youtube-url'
import { useGetHrefContext } from '../../context'
import { parseHostname } from '../../helpers/url'

interface LinkProps {
  href: string
  title?: string
  target?: string
}

const Link: React.FunctionComponent<LinkProps> = ({
  title,
  href,
  children,
  target,
}) => {
  const youtubeDetails = getYoutubeUrlDetails(href)
  const getUrl = useGetHrefContext()
  const hostname = parseHostname(getUrl())

  if (youtubeDetails) {
    return <YoutubeLink title={title} {...youtubeDetails} />
  }
  // Couldn't use react-router link since some of the internal link is not registered on the router
  return (
    <ExternalLink
      url={href}
      className={ExternalLinkStyles.ExternalLinkInText}
      target={target || parseHostname(href) === hostname ? '_self' : '_blank'}
    >
      {children}
    </ExternalLink>
  )
}

export default Link
